module.exports = __webpack_public_path__ + "img/The_Spotted_Cow@3x.ce4ecb29.webp";